import React from 'react'
import Skeleton from '@mui/lab/Skeleton'

const indexSearchInputStyle = { margin: '0 30px', width: 250 }

const SearchFields = props => {

  return (
    <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'center', padding: 20 }}>
      <div style={indexSearchInputStyle}>
        <Skeleton animation="wave" varint="rect" width="200" />

      </div>
      <div style={indexSearchInputStyle}>
        <Skeleton animation="wave" variant="rect" width="200" />
      </div>


    </div>
  )
}

export default SearchFields